import React from "react";

import { MagicNumberInput } from "./custom-metric-inputs/magic-number-input";
import { MetricSelector } from "./custom-metric-inputs/metric-selector/metric-selector";
import { OperatorSelection } from "./custom-metric-inputs/operator-selection";
import { useDisabledControls } from "./hooks/use-disabled-controls";

export const FormulaControls = () => {
  const isDisabled = useDisabledControls();

  return (
    <div className="border border-gray-2 rounded-md [grid-area:formula-controls]">
      <OperatorSelection isDisabled={isDisabled} />
      <MagicNumberInput isDisabled={isDisabled} />
      <MetricSelector isDisabled={isDisabled} />
    </div>
  );
};
